import { render, staticRenderFns } from "./BusquedaCodigosLiquidadoRegalados.vue?vue&type=template&id=599b9f32"
import script from "./BusquedaCodigosLiquidadoRegalados.vue?vue&type=script&lang=js"
export * from "./BusquedaCodigosLiquidadoRegalados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports